import { cx } from '@emotion/css';

import { PromotionalBanner } from '@phoenix/core/frontend/shared/feature/promotional-banner/promotional-banner';

import styles from '../overview/dashboard-overview.module.scss';

export const BannerDashboard = ({ isFirstSection = false, isLastSection = false }) => {
  return (
    <PromotionalBanner
      baseEventName="mystihl_banner"
      className={cx({
        [styles.bannerFirst]: isFirstSection,
        [styles.bannerLast]: isLastSection,
      })}
      id="banner_dashboard"
      staticTags={['imagesDashboard']}
    />
  );
};
